import { integrationsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';
import type { ApiResponse } from '~/features/onboarding/types/connection.types';

import type { GroupingMethodOption } from '../types/grouping-config.types';

/**
 * Fetch the default grouping-method options for a connector. Auth + the
 * `x-subsidiary-id` header are injected by the shared integrations client
 * interceptors, so callers just pass the connector code (e.g. `GOOGLE_MERCHANT`).
 */
export async function getDefaultGroupingConfig(
  connectorCode: string,
): Promise<GroupingMethodOption[]> {
  const res = await integrationsClient
    .get(endpoints.connectors.defaultGroupingConfig(connectorCode))
    .json<ApiResponse<GroupingMethodOption[]>>();
  return res.data;
}
